import * as React from 'react'

type Props = {
  children: React.ReactNode
}

export const CoreLayout = ({ children }: Props) => {
  return (
    <div className="module-core tw-padding-4 tw-m-1 tw-flex tw-min-w-[900px] tw-flex-[1] tw-flex-col tw-overflow-y-hidden tw-rounded-xl tw-border tw-border-base-300 tw-bg-base-100 tw-text-content-base">
      <main className="p-6 tw-overflow-y-auto">{children}</main>
    </div>
  )
}
